export default __webpack_public_path__ + "static/media/white-curve-line.694fc40f.svg";